import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const PageContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    padding: '20px 24px 32px',
    minHeight: 'calc(100vh - 64px)',
    boxSizing: 'border-box',
});

export const ContentContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'fileUploaded' && prop !== 'activeTab',
})(({ theme }) => ({
    width: '100%',
    maxWidth: 1080,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    position: 'relative',
}));

export const FullHeightCardWrapper = styled(Box)({
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    overflowY: 'auto',
});

export const TopRightButtonWrapper = styled(Box)({
    position: 'absolute',
    top: '16px',
    right: '16px',
    display: 'flex',
    justifyContent: 'flex-end',
    zIndex: 10,
});

export const UploadButton = styled('button')({
    backgroundColor: '#1976d2',
    color: '#fff',
    padding: '6px 16px',
    borderRadius: 4,
    border: 'none',
    cursor: 'pointer',
    '&:disabled': { opacity: 0.5, cursor: 'not-allowed' },
});
